import { Travel } from "@gen/travel/v1/common_pb";
import { Modal, Button } from "@thetreep/ui";
import { Trans, useTranslation } from "react-i18next";
import { CompactJourney } from "@pages/user/bookings/CompactJourney";
interface NoExchangeModalProps {
  travel?: Travel;
  isOpen: boolean;
  onClose: () => void;
  agencyName: string;
  workingHour: string;
  phoneNumber: string;
}

export function NoExchangeModal({
  travel,
  isOpen,
  onClose,
  agencyName,
  workingHour,
  phoneNumber,
}: NoExchangeModalProps) {
  const { t } = useTranslation();

  if (!travel || !travel.outward || !travel.inward) return null;

  return (
    <Modal size="small" isOpen={isOpen} onClose={onClose}>
      <div className="flex flex-col gap-4">
        <span className="font-jakarta font-bold text-text-strong text-[24px]">
          {t("booking.noExchange.title")}
        </span>
        <div className="text-neutral-900 whitespace-pre-line max-w-[600px]">
          <p className="font-roboto text-[16px] text-text-strong">
            <Trans
              t={t}
              values={{
                agencyName: agencyName,
              }}
            >
              booking.noExchange.text
            </Trans>
          </p>
          <p className="font-roboto text-[16px] text-text-strong mt-4">
            {" "}
            {t("booking.noExchange.phoneNumber")}:{" "}
            <strong> {phoneNumber} </strong>{" "}
          </p>
          <p className="font-roboto text-[16px] text-text-strong mb-4">
            {" "}
            {t("booking.noExchange.workingHours")}:{" "}
            <strong> {workingHour} </strong>{" "}
          </p>
        </div>
        <div className="flex flex-col gap-2 lg:flex-row lg:justify-between">
          <div className="flex flex-col gap-2 lg:flex-row lg:justify-between">
            <CompactJourney
              journey={travel.outward}
              travel={travel}
              displayPrice
            />
            <CompactJourney
              journey={travel.inward}
              travel={travel}
              displayPrice
            />
          </div>
        </div>
        <div className="flex gap-2 justify-end">
          <Button onClick={onClose} kind="outline" size="compact">
            {t("userBookings.offlineClose")}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
